import { SEARCH_BUYERS, SEARCH_BUYERS_ERROR, SEARCH_BUYERS_SUCCESS } from './SearchBuyerSection.actions'

const searchBuyerSectionState = {
  error: null,
  loading: false,
  options: []
}

/**
 * The search buyer section's reducer.
 */
const searchBuyerSectionReducer = (state = searchBuyerSectionState, { payload, type }) => {
  switch (type) {
    case SEARCH_BUYERS: {
      return { ...state, loading: true }
    }
    case SEARCH_BUYERS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case SEARCH_BUYERS_SUCCESS: {
      return { ...state, loading: false, options: payload.options }
    }
    default: {
      return state
    }
  }
}

export default searchBuyerSectionReducer
